import { useEffect, useState } from "react";
import PropTypes from 'prop-types';

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";

// API/MODELS
import bksAPI from "api/bks";
import userAPI from "api/user";
import crowdCountingAPI from "../../api/crowd_counting";

import { processDevicesData } from "helper/device";

import { Divider } from "@mui/material";
import { processCameraDeviceLocations } from "helper/crowds";
import moment from "moment";
import FromNow from "../../components/FromNow";
import FudgeSliders from "../../components/FudgeSliders";

const device_uuids = ["370028-3233510b-38373433", "480027-3233510b-38373433", "49002d-3233510b-38373433", "1d002e-3233510b-38373433"];

function wrapper(content) {
    return (
        <SoftBox p={3}
            sx={({ palette: { white }, boxShadows: { navbarBoxShadow }, borders: { borderRadius }, functions: { rgba, pxToRem } }) => ({
                boxShadow: navbarBoxShadow,
                backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
                // backgroundColor: rgba(white.main, 0.8),
                borderRadius: borderRadius.xl,
                height: 'calc(100% - 50px)',
                overflowY: 'auto',
                '::-webkit-scrollbar': {
                    backgroundColor: 'transparent',
                    width: '8px',
                },
                '::-webkit-scrollbar-track': { /* background of the scrollbar except button or resizer */
                    backgroundColor: 'transparent',
                },
                '::-webkit-scrollbar-thumb': { /* scrollbar itself */
                    backgroundColor: '#babac0',
                    borderRadius: '6px',
                    border: `1px solid ${rgba(white.main, 0.8)}`,
                },
                '::-webkit-scrollbar-button': { /* set button(top and bottom of the scrollbar) */
                    display: 'none',
                },
            })}
        >
            <SoftBox mt={{ xs: 1, lg: 3 }} mb={1}>
                {content}
            </SoftBox>
        </SoftBox>
    )
}

function CrowdCountingFudgeMultiplier({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {
    // DevicePreviewCard dropdown menu state

    bksAPI.loadToken(useAuth0());
    crowdCountingAPI.loadToken(useAuth0());
    userAPI.loadToken(useAuth0());

    const { user } = useAuth0();

    const devices = useQuery({
        queryKey: ['getDevices', device_uuids],
        queryFn: async () => {
            return await bksAPI.getDevices(device_uuids);
        },
        refetchInterval: 20 * 1000,
    });

    const crowdCountingConfig = useQuery({
        queryKey: ['crowdCountingConfig', ...device_uuids],
        queryFn: async () => {
            try {
                return await crowdCountingAPI.getConfig(device_uuids);
            }
            catch (e) {
                console.log(e);
            }
        },
        refetchInterval: 20 * 1000,
    });

    const selected_user = useQuery({
        queryKey: ['getUserByEmail', user.email.toLowerCase()],
        queryFn: async () => {
            return await userAPI.getUserByEmail(user.email.toLowerCase());
        }
    });

    useEffect(() => {
        setSidebarState('sidenav');
        setNavTitle(['fudge multi']);
    }, [sidebarState, navTitle]);

    if (crowdCountingConfig.isLoading || devices.isLoading || selected_user.isLoading) {
        return wrapper('Loading...');
    }

    if (crowdCountingConfig.error || devices.error || selected_user.error) {
        if (devices.error) {
            var error = devices.error;
        }
        else if (crowdCountingConfig.error) {
            var error = crowdCountingConfig.error;
        }
        else if (selected_user.error) {
            var error = selected_user.error;
        }
        return wrapper("An error has occurred: " + error.message);
    }

    if (!crowdCountingConfig.data || !devices.data || !selected_user.data) {
        return wrapper('Loading...');
    }


    var devices_data = processDevicesData(devices.data, true, 'camera');
    devices_data = processCameraDeviceLocations(devices_data, Object.values(crowdCountingConfig.data.cameras));
    devices_data = devices_data.sort((a, b) => {
        return a.name.split('#')[1] - b.name.split('#')[1];
    })
    // console.log(devices_data);

    return wrapper((
        <SoftBox>
            <FromNow epoch={crowdCountingConfig.dataUpdatedAt} />
            <Divider />
            <Grid container>
                {devices_data.map(function (device, index) {
                    return (
                        <Grid item xs={3} key={index}>
                            <FudgeSliders device={device} multiplier={device.location.multiplier} />
                            <Divider />
                        </Grid>
                    )
                })}
            </Grid>
        </SoftBox>
    ));
}

CrowdCountingFudgeMultiplier.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default CrowdCountingFudgeMultiplier;